import { Injectable } from '@angular/core';
import * as CalendarActions from '@app/pcs/actions/calendar';
import { CalendarActionTypes } from '@app/pcs/actions/calendar';
import { Calendar } from '@app/pcs/models';
import { createCalendar } from '@app/pcs/models/calendar.schema';
import { CatalogueSearchItem } from '@app/pcs/pap-search/models/catalogue-search-item';
import { CalendarRestService } from '@app/pcs/services/calendar-rest.service';
import { updateGridElements } from '@app/pcs/util';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mapPayload } from '@util';
import * as R from 'ramda';
import { of } from 'rxjs';
import { catchError, exhaustMap, switchMap } from 'rxjs/operators';

const shouldUpdateGridCalendar = R.curry((calendar: Calendar, gridElement: CatalogueSearchItem) => R.path(
  ['calendar', 'calId'], gridElement) === R.prop('calId', calendar));

const updateGridCalendar = R.curry((calendar, gridElement: CatalogueSearchItem) => R.mergeRight(gridElement, {calendar}));

@Injectable()
export class CalendarEffects {

  fetchCalendar$ = createEffect(() => this.actions$.pipe(
    ofType<CalendarActions.FetchCalendar>(CalendarActionTypes.FetchCalendar),
    mapPayload(),
    exhaustMap(({calendarId, validityPeriod}) => this.calendarRestService.fetchCalendar(calendarId, validityPeriod).pipe(
      switchMap((result) => {
        const calendar: Calendar = createCalendar(result);
        return [
          updateGridElements(shouldUpdateGridCalendar(calendar), updateGridCalendar(calendar))
        ];
      }),
      catchError(error => of(new CalendarActions.FetchCalendarFail(error)))
    ))
  ));

  constructor(private actions$: Actions, private calendarRestService: CalendarRestService) {
  }

}
